import { AccountantList } from '../../../components/Accountant';
import { AuthenticatedLayout } from '../../../layouts/AuthenticatedLayout/AuthenticatedLayout';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { FC } from 'react';
import { IAppState } from '../../../store/reducers';
import { useSelector } from 'react-redux';

export interface IAccountantListPage { }

export const AccountantListPage: FC<IAccountantListPage> = (
  props: IAccountantListPage
) => {
  const homePathRoute = useSelector((state:IAppState) => state.HomePagePath.path)

  return (
    <AuthenticatedLayout
      pageTitle="Accountant List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName="/AccountantDashboard"
      breadcrumbLinks={[{text: 'Accountants', navigateTo: '/accountant/list'}]}
      mainContents={<AccountantList />}
    />
  );
};
